/* ABCD cart drawer: reward ladder (23 Oct 2026).
   Replaces the old milestone bar and "choose your free shoe" block at the top of the cart drawer
   with one premium progress card:
     150 EUR  free socks (shipping is free on every order)
     250 EUR  free laces
     400 EUR  a free shoe (UGG or New Balance, EUR 70 to 100): the automatic discount "Free shoe over 400"
   24 Oct 2026: the free shoe is switched off (shoeShop 0 in OlyxFixesConfig), so the ladder shows two
   steps only: socks and laces. Set shoeShop back to a threshold to bring the third step back.
   Free shipping (delivery rate) and the free shoe (discount) are real Shopify rules. The socks and
   laces are stored as line item properties ("Cadeau sokken", "Cadeau veters") on the first line, NOT
   as extra products: a free product line would count as an item for the 5 and 10 percent bundle
   discounts. The properties show in checkout, the confirmation mail and the order, so the gift is packed.
   Everything is measured on the cart total after discounts, like the shipping rate. If this script
   fails, the old bar stays visible (the old block is only hidden once the ladder is mounted). */
(function () {
  'use strict';

  var root = document.getElementById('CartDrawerPro');
  if (!root || root.dataset.abcdLadder) return;
  var anchor = root.querySelector('[data-cdp-ms]');
  if (!anchor || !anchor.parentNode) return;
  root.dataset.abcdLadder = '1';

  var lang = String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LOCALE = { nl: 'nl-BE', fr: 'fr-BE', de: 'de-DE', it: 'it-IT', en: 'en-IE' }[lang] || 'nl-BE';

  /* ---------- texts ---------- */
  var T = {
    nl: {
      giftsT: 'Je gratis cadeaus', change: 'Wijzigen', done: 'Klaar', eyebrow: 'Jouw voordeel', free: 'GRATIS',
      n1: 'Sokken', n2: 'Veters', n3: 'Gratis paar',
      A: 'Nog <b>[x]</b> voor gratis sokken', Asub: 'Vanaf [t2] krijg je er ook gratis veters bij.',
      B: 'Gratis sokken ontgrendeld! Nog <b>[x]</b> voor gratis veters', Bsub: 'Je gratis sokken gaan mee met je bestelling.',
      C: 'Gratis sokken en veters ontgrendeld!', Csub: 'Ze gaan gratis mee met je bestelling.',
      D: 'Gratis paar ontgrendeld!', Dsub: 'Voeg een UGG of New Balance van [min] tot [max] toe. Het goedkoopste paar is gratis, één per bestelling.',
      E: 'Alles ontgrendeld!', Esub: 'Je gratis paar zit in je winkelwagen.',
      ugg: 'Kies UGG', nb: 'Kies New Balance',
      socksOk: 'Sokken', lacesOk: 'Veters',
      colors: { Zwart: 'Zwart', Wit: 'Wit', Blauw: 'Blauw', Rood: 'Rood', Beige: 'Beige', Roze: 'Roze' }
    },
    fr: {
      giftsT: 'Vos cadeaux offerts', change: 'Modifier', done: 'Terminé', eyebrow: 'Votre avantage', free: 'OFFERTE',
      n1: 'Chaussettes', n2: 'Lacets', n3: 'Paire offerte',
      A: 'Plus que <b>[x]</b> pour des chaussettes offertes', Asub: 'Dès [t2], des lacets offerts en plus.',
      B: 'Chaussettes offertes ! Plus que <b>[x]</b> pour des lacets offerts', Bsub: 'Vos chaussettes offertes partent avec votre commande.',
      C: 'Chaussettes et lacets offerts débloqués !', Csub: 'Ils partent gratuitement avec votre commande.',
      D: 'Paire offerte débloquée !', Dsub: 'Ajoutez une UGG ou New Balance de [min] à [max]. La moins chère est offerte, une par commande.',
      E: 'Tout est débloqué !', Esub: 'Votre paire offerte est dans votre panier.',
      ugg: 'Choisir une UGG', nb: 'Choisir une New Balance',
      socksOk: 'Chaussettes', lacesOk: 'Lacets',
      colors: { Zwart: 'Noir', Wit: 'Blanc', Blauw: 'Bleu', Rood: 'Rouge', Beige: 'Beige', Roze: 'Rose' }
    },
    de: {
      giftsT: 'Deine Gratisgeschenke', change: 'Ändern', done: 'Fertig', eyebrow: 'Dein Vorteil', free: 'GRATIS',
      n1: 'Socken', n2: 'Schnürsenkel', n3: 'Gratis-Paar',
      A: 'Noch <b>[x]</b> für gratis Socken', Asub: 'Ab [t2] gibt es auch gratis Schnürsenkel.',
      B: 'Gratis Socken freigeschaltet! Noch <b>[x]</b> für gratis Schnürsenkel', Bsub: 'Deine gratis Socken kommen mit deiner Bestellung.',
      C: 'Gratis Socken und Schnürsenkel freigeschaltet!', Csub: 'Sie kommen kostenlos mit deiner Bestellung.',
      D: 'Gratis-Paar freigeschaltet!', Dsub: 'Füge ein Paar UGG oder New Balance von [min] bis [max] hinzu. Das günstigste Paar ist gratis, eins pro Bestellung.',
      E: 'Alles freigeschaltet!', Esub: 'Dein Gratis-Paar liegt im Warenkorb.',
      ugg: 'UGG wählen', nb: 'New Balance wählen',
      socksOk: 'Socken', lacesOk: 'Schnürsenkel',
      colors: { Zwart: 'Schwarz', Wit: 'Weiß', Blauw: 'Blau', Rood: 'Rot', Beige: 'Beige', Roze: 'Rosa' }
    },
    it: {
      giftsT: 'I tuoi regali gratis', change: 'Modifica', done: 'Fatto', eyebrow: 'Il tuo vantaggio', free: 'GRATIS',
      n1: 'Calze', n2: 'Lacci', n3: 'Paio gratis',
      A: 'Ancora <b>[x]</b> per le calze gratis', Asub: 'Da [t2] ricevi anche i lacci gratis.',
      B: 'Calze gratis sbloccate! Ancora <b>[x]</b> per i lacci gratis', Bsub: 'Le tue calze gratis arrivano con il tuo ordine.',
      C: 'Calze e lacci gratis sbloccati!', Csub: 'Arrivano gratis con il tuo ordine.',
      D: 'Paio gratis sbloccato!', Dsub: 'Aggiungi un paio UGG o New Balance da [min] a [max]. Il più economico è gratis, uno per ordine.',
      E: 'Tutto sbloccato!', Esub: 'Il tuo paio gratis è nel carrello.',
      ugg: 'Scegli UGG', nb: 'Scegli New Balance',
      socksOk: 'Calze', lacesOk: 'Lacci',
      colors: { Zwart: 'Nero', Wit: 'Bianco', Blauw: 'Blu', Rood: 'Rosso', Beige: 'Beige', Roze: 'Rosa' }
    },
    en: {
      giftsT: 'Your free gifts', change: 'Change', done: 'Done', eyebrow: 'Your reward', free: 'FREE',
      n1: 'Socks', n2: 'Laces', n3: 'Free pair',
      A: '<b>[x]</b> to go for free socks', Asub: 'From [t2] you also get free laces.',
      B: 'Free socks unlocked! <b>[x]</b> to go for free laces', Bsub: 'Your free socks ship with your order.',
      C: 'Free socks and laces unlocked!', Csub: 'They ship free with your order.',
      D: 'Free pair unlocked!', Dsub: 'Add a UGG or New Balance from [min] to [max]. The cheapest pair is free, one per order.',
      E: 'Everything unlocked!', Esub: 'Your free pair is in your cart.',
      ugg: 'Choose UGG', nb: 'Choose New Balance',
      socksOk: 'Socks', lacesOk: 'Laces',
      colors: { Zwart: 'Black', Wit: 'White', Blauw: 'Blue', Rood: 'Red', Beige: 'Beige', Roze: 'Pink' }
    }
  };
  var L = T[lang] || T.nl;

  var SOCK_COLORS = ['Zwart', 'Wit'];
  var SOCK_SIZES = ['34-38', '38-42', '42-46'];
  var LACE_COLORS = ['Blauw', 'Rood', 'Zwart', 'Beige', 'Wit', 'Roze'];
  var LACE_DOT = { Blauw: '#2563eb', Rood: '#dc2626', Zwart: '#111827', Beige: '#d6c3a1', Wit: '#ffffff', Roze: '#f472b6' };
  var SOCK_DOT = { Zwart: '#111827', Wit: '#ffffff' };
  var KEY_SOCKS = 'Cadeau sokken';
  var KEY_LACES = 'Cadeau veters';

  /* ---------- thresholds in the visitor's currency (cents) ---------- */
  function rate() {
    try { return parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) { return 1; }
  }
  function cfg() { return window.OlyxFixesConfig || {}; }
  function t1() { return cfg().freeShippingExact ? Math.round(cfg().freeShippingExact * 100) : Math.round(15000 * rate()); }
  function t2() { return Math.round(25000 * rate()); }
  function t3() { return cfg().shoeExact ? Math.round(cfg().shoeExact * 100) : Math.round(40000 * rate()); }
  /* no free shoe: OlyxFixesConfig.shoeShop is 0 */
  function noShoe() { var c = cfg(); return !(Number(c.shoeShop) > 0); }
  function band() {
    var c = cfg();
    return {
      min: Math.round((c.shoeMinExact || 100 * rate()) * 100),
      max: Math.round((c.shoeMaxExact || 130 * rate()) * 100)
    };
  }

  /* ---------- money ---------- */
  var cur = 'EUR';
  function money(cents, short) {
    var v = (Number(cents) || 0) / 100;
    var s;
    try {
      s = new Intl.NumberFormat(LOCALE, { style: 'currency', currency: cur }).format(v).replace(/ | /g, '');
    } catch (e) { s = '€' + v.toFixed(2).replace('.', ','); }
    return short ? s.replace(/[.,]00(?!\d)/, '') : s;
  }

  /* ---------- cart helpers ---------- */
  function protVid() {
    try {
      var el = document.getElementById('CartDrawerProExtras');
      return el ? Number(JSON.parse(el.textContent).protectionVariantId) || 0 : 0;
    } catch (e) { return 0; }
  }
  var PROT = protVid();
  function isProt(i) { return !!PROT && Number(i.variant_id) === PROT; }
  var RE_SHOE = /^(sneakers?|boots?|slippers?|clogs?|sandals?)$/i;
  var RE_FREE_SHOE = /free shoe|gratis schoen|schoen gratis/i;

  function analyse(cart) {
    var items = (cart.items || []).filter(function (i) { return !isProt(i); });
    var net = Number(cart.total_price) || 0;
    (cart.items || []).forEach(function (i) { if (isProt(i)) net -= Number(i.final_line_price) || 0; });
    var count = 0, shoeSpend = 0, applied = false;
    items.forEach(function (i) {
      count += i.quantity || 0;
      var allocs = i.line_level_discount_allocations || [];
      for (var k = 0; k < allocs.length; k++) {
        var app = allocs[k].discount_application;
        if (app && RE_FREE_SHOE.test(String(app.title || '')) && Number(allocs[k].amount) > 0) applied = true;
      }
      if (RE_SHOE.test(String(i.product_type || '').trim())) shoeSpend += Number(i.final_line_price) || 0;
    });
    var props = {};
    items.forEach(function (i) {
      var p = i.properties || {};
      if (p[KEY_SOCKS] && !props[KEY_SOCKS]) props[KEY_SOCKS] = p[KEY_SOCKS];
      if (p[KEY_LACES] && !props[KEY_LACES]) props[KEY_LACES] = p[KEY_LACES];
    });
    return { items: items, net: net, count: count, shoeSpend: shoeSpend, applied: applied, props: props, currency: cart.currency || 'EUR' };
  }

  /* ---------- markup ---------- */
  var ICON = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 6.5h11v9h-11zM13.5 9.5h4l3 3v3h-7z"/><circle cx="6.5" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    shoe: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 17v-3l4-1 2-3 3 2 5 1c2 .4 4 1.3 4 3v1z"/><path d="M3 17h18"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>'
  };

  var el = document.createElement('section');
  el.className = 'AbcdLad';
  el.setAttribute('data-abcd-ladder', '');
  el.hidden = true;
  el.innerHTML =
    '<div class="AbcdLad__top">' +
      '<div class="AbcdLad__copy">' +
        '<p class="AbcdLad__eyebrow"></p>' +
        '<p class="AbcdLad__title" aria-live="polite"></p>' +
        '<p class="AbcdLad__sub"></p>' +
      '</div>' +
      '<a class="AbcdLad__prize" href="#" data-prize hidden>' +
        '<span class="AbcdLad__thumbs" data-thumbs></span>' +
        '<span class="AbcdLad__ribbon"></span>' +
      '</a>' +
    '</div>' +
    '<div class="AbcdLad__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-label="' + L.eyebrow + '">' +
      '<span class="AbcdLad__rail"><span class="AbcdLad__fill" data-fill></span></span>' +
      '<span class="AbcdLad__node AbcdLad__node--1" data-node="1" style="left:50%">' + ICON.truck + '</span>' +
      '<span class="AbcdLad__node AbcdLad__node--2" data-node="2" style="left:75%">' + ICON.gift + '</span>' +
      '<span class="AbcdLad__node AbcdLad__node--3" data-node="3" style="left:100%">' + ICON.shoe + '</span>' +
    '</div>' +
    '<div class="AbcdLad__labels">' +
      '<span class="AbcdLad__lab" data-lab="1" style="left:50%"><b></b><i></i></span>' +
      '<span class="AbcdLad__lab" data-lab="2" style="left:75%"><b></b><i></i></span>' +
      '<span class="AbcdLad__lab AbcdLad__lab--end" data-lab="3" style="left:100%"><b></b><i></i></span>' +
    '</div>' +
    '<div class="AbcdLad__tiers" data-tiers role="list">' +
      '<span class="AbcdLad__tier" role="listitem" data-tier="1"><strong></strong><em></em></span>' +
      '<span class="AbcdLad__tier" role="listitem" data-tier="2"><strong></strong><em></em></span>' +
      '<span class="AbcdLad__tier" role="listitem" data-tier="3"><strong></strong><em></em></span>' +
    '</div>' +
    '<div class="AbcdLad__cta" data-cta hidden>' +
      '<a class="AbcdLad__btn" href="#" data-ugg></a>' +
      '<a class="AbcdLad__btn" href="#" data-nb></a>' +
    '</div>' +
    '';
  if (noShoe()) {
    /* two steps: socks halfway, laces at the end of the bar */
    var n2 = el.querySelector('[data-node="2"]'), l2 = el.querySelector('[data-lab="2"]');
    n2.style.left = '100%'; l2.style.left = '100%'; l2.classList.add('AbcdLad__lab--end');
    el.querySelector('[data-node="3"]').style.display = 'none';
    el.querySelector('[data-lab="3"]').style.display = 'none';
  }
  var gifts = document.createElement('div');
  gifts.className = 'AbcdGifts';
  gifts.setAttribute('data-abcd-gifts', '');
  gifts.hidden = true;

  var css = document.createElement('style');
  css.id = 'abcd-ladder-css';
  css.textContent = [
    '#CartDrawerPro.abcd-ladder-on .cdp-ms, #CartDrawerPro.abcd-ladder-on .cdp-shoe { display: none !important; }',
    '#CartDrawerPro .AbcdLad { position: relative; margin: 0 16px 10px; padding: 14px 14px 10px; border-radius: 18px; color: #fff; overflow: hidden;',
    '  background: radial-gradient(120% 140% at 100% 0%, rgba(168,85,247,.55) 0%, rgba(168,85,247,0) 55%), linear-gradient(135deg, #160d33 0%, #241255 55%, #3b1a7a 100%);',
    '  box-shadow: 0 10px 28px rgba(36,18,85,.35), inset 0 0 0 1px rgba(255,255,255,.08); }',
    '#CartDrawerPro .AbcdLad[hidden] { display: none; }',
    '#CartDrawerPro .AbcdLad__top { display: flex; align-items: center; gap: 10px; }',
    '#CartDrawerPro .AbcdLad__copy { flex: 1 1 auto; min-width: 0; }',
    '#CartDrawerPro .AbcdLad__eyebrow { margin: 0 0 3px; font-size: 10px; font-weight: 800; letter-spacing: .14em; text-transform: uppercase; color: #fbbf24; }',
    '#CartDrawerPro .AbcdLad__title { margin: 0; font-size: 16px; line-height: 1.22; font-weight: 800; color: #fff; }',
    '#CartDrawerPro .AbcdLad__title b { color: #34d399; font-weight: 900; }',
    '#CartDrawerPro .AbcdLad__sub { margin: 4px 0 0; font-size: 12px; line-height: 1.35; color: rgba(255,255,255,.72); }',
    '#CartDrawerPro .AbcdLad__sub:empty { display: none; }',
    '#CartDrawerPro .AbcdLad__prize { position: relative; flex: 0 0 auto; display: block; width: 84px; height: 62px; text-decoration: none; }',
    '#CartDrawerPro .AbcdLad__prize[hidden] { display: none; }',
    '#CartDrawerPro .AbcdLad__thumbs { position: absolute; inset: 0; }',
    '#CartDrawerPro .AbcdLad__thumbs img { position: absolute; top: 4px; width: 44px; height: 44px; object-fit: cover; border-radius: 50%; background: #fff; border: 2px solid #fbbf24; box-shadow: 0 4px 10px rgba(0,0,0,.35); }',
    '#CartDrawerPro .AbcdLad__thumbs img:nth-child(1) { left: 0; z-index: 3; }',
    '#CartDrawerPro .AbcdLad__thumbs img:nth-child(2) { left: 20px; z-index: 2; }',
    '#CartDrawerPro .AbcdLad__thumbs img:nth-child(3) { left: 40px; z-index: 1; }',
    '#CartDrawerPro .AbcdLad__ribbon { position: absolute; left: 50%; bottom: 0; transform: translateX(-50%); padding: 2px 9px; border-radius: 999px; background: linear-gradient(90deg, #fbbf24, #f59e0b); color: #3b1a00; font-size: 10px; font-weight: 900; letter-spacing: .08em; white-space: nowrap; box-shadow: 0 3px 8px rgba(0,0,0,.3); }',
    '#CartDrawerPro .AbcdLad.is-locked-shoe .AbcdLad__thumbs img { filter: saturate(.55) brightness(.9); }',
    '#CartDrawerPro .AbcdLad__track { position: relative; height: 40px; margin: 8px 18px 0 2px; }',
    '#CartDrawerPro .AbcdLad__rail { position: absolute; left: 0; right: 0; top: 17px; height: 8px; border-radius: 99px; background: rgba(255,255,255,.14); overflow: hidden; }',
    '#CartDrawerPro .AbcdLad__fill { position: absolute; left: 0; top: 0; bottom: 0; width: 0; border-radius: 99px; background: linear-gradient(90deg, #a78bfa, #34d399 70%, #fbbf24); transition: width .6s cubic-bezier(.2,.8,.3,1); box-shadow: 0 0 12px rgba(52,211,153,.7); }',
    '#CartDrawerPro .AbcdLad__fill::after { content: ""; position: absolute; inset: 0; background: linear-gradient(110deg, transparent 30%, rgba(255,255,255,.55) 50%, transparent 70%); background-size: 200% 100%; animation: abcdLadShine 2.4s linear infinite; }',
    '@keyframes abcdLadShine { from { background-position: 200% 0; } to { background-position: -200% 0; } }',
    '#CartDrawerPro .AbcdLad__node { position: absolute; top: 5px; width: 32px; height: 32px; margin-left: -16px; display: grid; place-items: center; border-radius: 50%; color: rgba(255,255,255,.75); background: #2b1a5c; border: 2px solid rgba(255,255,255,.28); transition: transform .3s, background .3s, border-color .3s, box-shadow .3s; }',
    '#CartDrawerPro .AbcdLad__node svg { width: 16px; height: 16px; }',
    '#CartDrawerPro .AbcdLad__node--3 { width: 38px; height: 38px; margin-left: -19px; top: 2px; }',
    '#CartDrawerPro .AbcdLad__node--3 svg { width: 19px; height: 19px; }',
    '#CartDrawerPro .AbcdLad__node.is-next { color: #fff; border-color: #a78bfa; background: #4c1d95; box-shadow: 0 0 0 4px rgba(167,139,250,.28); animation: abcdLadPulse 1.7s ease-in-out infinite; }',
    '#CartDrawerPro .AbcdLad__node.is-done { color: #052e1a; border-color: #34d399; background: #34d399; box-shadow: 0 0 14px rgba(52,211,153,.65); }',
    '#CartDrawerPro .AbcdLad__node--3.is-done { border-color: #fbbf24; background: linear-gradient(135deg, #fde68a, #f59e0b); color: #3b1a00; box-shadow: 0 0 18px rgba(251,191,36,.8); }',
    '#CartDrawerPro .AbcdLad__node--3:not(.is-done) { border-color: rgba(251,191,36,.7); color: #fde68a; }',
    '#CartDrawerPro .AbcdLad__node.is-pop { animation: abcdLadPop .8s cubic-bezier(.2,.9,.3,1.4); }',
    '@keyframes abcdLadPulse { 0%, 100% { box-shadow: 0 0 0 3px rgba(167,139,250,.25); } 50% { box-shadow: 0 0 0 8px rgba(167,139,250,.08); } }',
    '@keyframes abcdLadPop { 0% { transform: scale(.6); } 60% { transform: scale(1.35); } 100% { transform: scale(1); } }',
    '#CartDrawerPro .AbcdLad__labels { position: relative; height: 37px; margin: 2px 18px 0 2px; }',
    '#CartDrawerPro .AbcdLad__lab { position: absolute; top: 0; transform: translateX(-50%); width: 92px; text-align: center; line-height: 1.15; }',
    '#CartDrawerPro .AbcdLad__lab--end { transform: translateX(-72%); text-align: right; width: 84px; }',
    '#CartDrawerPro .AbcdLad__lab b { display: block; font-size: 12px; font-weight: 900; color: #fff; }',
    '#CartDrawerPro .AbcdLad__lab i { display: block; margin-top: 1px; font-style: normal; font-size: 10.5px; font-weight: 600; color: rgba(255,255,255,.7); }',
    '#CartDrawerPro .AbcdLad__lab.is-done b { color: #34d399; }',
    '#CartDrawerPro .AbcdLad__lab--end.is-done b { color: #fbbf24; }',
    '#CartDrawerPro .AbcdLad__cta { display: flex; gap: 8px; margin: 6px 0 4px; }',
    '#CartDrawerPro .AbcdLad__cta[hidden] { display: none; }',
    '#CartDrawerPro .AbcdLad__btn { flex: 1 1 0; display: flex; align-items: center; justify-content: center; min-height: 40px; padding: 0 8px; border-radius: 12px; background: linear-gradient(135deg, #fde68a, #f59e0b); color: #3b1a00; font-size: 13px; font-weight: 900; text-decoration: none; box-shadow: 0 6px 14px rgba(245,158,11,.4); animation: abcdLadPulseBtn 1.8s ease-in-out infinite; }',
    '@keyframes abcdLadPulseBtn { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.03); } }',
    '#CartDrawerPro .AbcdLad__tiers { display: grid; grid-template-columns: repeat(3, 1fr); gap: 7px; margin: 6px 0 8px; }',
    '#CartDrawerPro .AbcdLad__tier { position: relative; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 3px; padding: 7px 4px; border: 1.5px solid rgba(255,255,255,.22); border-radius: 12px; background: rgba(255,255,255,.06); text-align: center; line-height: 1.15; }',
    '#CartDrawerPro .AbcdLad__tier strong { font-size: 12px; font-weight: 800; color: #fff; }',
    '#CartDrawerPro .AbcdLad__tier em { font-style: normal; font-size: 11px; font-weight: 800; color: rgba(255,255,255,.7); }',
    '#CartDrawerPro .AbcdLad__tier:nth-child(2) em { padding: 2px 9px; border-radius: 999px; background: #7c3aed; color: #fff; }',
    '#CartDrawerPro .AbcdLad__tier:nth-child(3) { border-color: rgba(52,211,153,.7); background: rgba(52,211,153,.12); }',
    '#CartDrawerPro .AbcdLad__tier:nth-child(3) em { padding: 2px 9px; border-radius: 999px; background: #16a34a; color: #fff; }',
    '#CartDrawerPro .AbcdLad__tier:nth-child(3)::after { content: "\\2605"; position: absolute; top: -8px; right: -5px; width: 20px; height: 20px; display: grid; place-items: center; border-radius: 50%; background: #fbbf24; color: #fff; font-size: 11px; box-shadow: 0 2px 6px rgba(0,0,0,.35); }',
    '#CartDrawerPro .AbcdLad__tier.is-active { border: 2px solid #fff; background: rgba(255,255,255,.14); }',
    '#CartDrawerPro .AbcdLad__tier.is-active strong::before { content: "\\2713\\00a0"; color: #34d399; }',
    '#CartDrawerPro .AbcdLad__tier:nth-child(3).is-active { border-color: #34d399; box-shadow: 0 0 0 3px rgba(52,211,153,.22); }',
    '#CartDrawerPro .AbcdLad__tier.is-next { border: 2px dashed #a78bfa; background: rgba(167,139,250,.12); animation: abcdNextPulse 1.8s ease-in-out infinite; }',
    '#CartDrawerPro .AbcdLad__tier:nth-child(3).is-next { border-color: #34d399; }',
    '#CartDrawerPro .AbcdGifts { margin: 0; }',
    '#CartDrawerPro .AbcdGifts[hidden] { display: none; }',
    '#CartDrawerPro .AbcdGifts .AbcdGift { padding: 6px 10px; border-radius: 11px; background: transparent; border: 1px solid rgba(255,255,255,.28); color: #fff; }',
    '#CartDrawerPro .AbcdGift__top { display: flex; align-items: center; gap: 7px; }',
    '#CartDrawerPro .AbcdGift__top svg { width: 15px; height: 15px; color: #fbbf24; flex: 0 0 auto; }',
    '#CartDrawerPro .AbcdGift__top strong { flex: 1 1 auto; font-size: 12.5px; font-weight: 800; color: #fff; }',
    '#CartDrawerPro .AbcdGift__top button { border: 0; background: none; color: #fbbf24; font-size: 11.5px; font-weight: 700; text-decoration: underline; cursor: pointer; font-family: inherit; padding: 4px 2px; }',
    '#CartDrawerPro .AbcdGift__list { display: flex; flex-wrap: wrap; gap: 2px 12px; margin: 1px 0 1px 22px; font-size: 12px; color: rgba(255,255,255,.78); }',
    '#CartDrawerPro .AbcdGift__list b { font-weight: 800; color: #fff; }',
    '#CartDrawerPro .AbcdGift__edit { margin: 8px 0 2px; padding-top: 4px; border-top: 1px solid rgba(255,255,255,.18); }',
    '#CartDrawerPro .AbcdGift__edit p { margin: 7px 0 5px; font-size: 11.5px; font-weight: 800; color: rgba(255,255,255,.85); }',
    '#CartDrawerPro .AbcdGift__chips { display: flex; flex-wrap: wrap; gap: 6px; }',
    '#CartDrawerPro .AbcdGift__chips + .AbcdGift__chips { margin-top: 6px; }',
    '#CartDrawerPro .AbcdGift__chip { display: inline-flex; align-items: center; gap: 6px; min-height: 32px; padding: 0 11px; border: 1.5px solid rgba(255,255,255,.3); border-radius: 999px; background: rgba(255,255,255,.06); color: #fff; font-size: 12px; font-weight: 700; cursor: pointer; font-family: inherit; }',
    '#CartDrawerPro .AbcdGift__chip.is-on { border-color: #34d399; background: rgba(52,211,153,.2); }',
    '#CartDrawerPro .AbcdGift__dot { width: 12px; height: 12px; border-radius: 50%; border: 1px solid rgba(255,255,255,.55); }',
    '#CartDrawerPro.abcd-ladder-on .OxUp--cart { display: none !important; }',
    '@keyframes abcdNextPulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.035); } }',
    '@media (max-height: 700px) { #CartDrawerPro .AbcdLad__tiers { display: none; } }',
    '#CartDrawerPro .AbcdLad { flex: 0 0 auto; }',
    '@media (max-height: 880px) { #CartDrawerPro.abcd-ladder-on .cdp-trust { display: none; } #CartDrawerPro .AbcdLad[data-state="A"] .AbcdLad__sub, #CartDrawerPro .AbcdLad[data-state="B"] .AbcdLad__sub, #CartDrawerPro .AbcdLad[data-state="C"] .AbcdLad__sub { display: none; } #CartDrawerPro .AbcdLad__eyebrow { display: none; } #CartDrawerPro .OxUp--cart .OxUp__Row--cut { display: none; } }',
    '@media (max-width: 400px) { #CartDrawerPro .AbcdLad { margin: 0 12px 8px; padding: 12px 12px 8px; } #CartDrawerPro .AbcdLad__title { font-size: 15px; } #CartDrawerPro .AbcdLad__prize { width: 72px; } #CartDrawerPro .AbcdLad__thumbs img { width: 38px; height: 38px; } #CartDrawerPro .AbcdLad__thumbs img:nth-child(2) { left: 17px; } #CartDrawerPro .AbcdLad__thumbs img:nth-child(3) { left: 34px; } #CartDrawerPro .AbcdLad__lab { width: 84px; } }',
    '@media (prefers-reduced-motion: reduce) { #CartDrawerPro .AbcdLad__node, #CartDrawerPro .AbcdLad__fill, #CartDrawerPro .AbcdLad__fill::after, #CartDrawerPro .AbcdLad__btn { animation: none !important; transition: none !important; } }'
  ].join('\n');
  (document.head || document.documentElement).appendChild(css);

  var q = function (s) { return el.querySelector(s); };
  var qa = function (s) { return el.querySelectorAll(s); };
  var tTitle = q('.AbcdLad__title');
  var tSub = q('.AbcdLad__sub');
  var tEye = q('.AbcdLad__eyebrow');
  var tFill = q('[data-fill]');
  var track = q('.AbcdLad__track');
  var prize = q('[data-prize]');
  var thumbs = q('[data-thumbs]');
  var cta = q('[data-cta]');
  var giftsBox = gifts;
  var ribbon = q('.AbcdLad__ribbon');
  tEye.textContent = L.eyebrow;
  ribbon.textContent = L.free;
  q('[data-prize]').href = ROOT + 'collections/gratis-schoen-new-balance';
  q('[data-ugg]').href = ROOT + 'collections/gratis-schoen-ugg';
  q('[data-nb]').href = ROOT + 'collections/gratis-schoen-new-balance';
  q('[data-prize]').setAttribute('aria-label', L.n3);
  q('[data-ugg]').textContent = L.ugg;
  q('[data-nb]').textContent = L.nb;

  anchor.parentNode.insertBefore(el, anchor);
  el.appendChild(gifts);
  root.classList.add('abcd-ladder-on');

  /* ---------- shoe thumbnails (real products from the free-shoe lists) ---------- */
  function loadPrize() {
    var cached = null;
    try { cached = JSON.parse(sessionStorage.getItem('abcd_prize_v1') || 'null'); } catch (e) {}
    if (cached && cached.t && Date.now() - cached.t < 3600000 && cached.u && cached.u.length) { showThumbs(cached.u); return; }
    function pick(handle, n) {
      return fetch(ROOT + 'collections/' + handle + '/products.json?limit=8', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var out = [];
          (d.products || []).forEach(function (p) {
            if (out.length >= n) return;
            var ok = (p.variants || []).some(function (v) { var bb = band(), cents = Math.round(parseFloat(v.price) * 100); return v.available && cents >= bb.min && cents <= bb.max; });
            var img = p.images && p.images[0] && p.images[0].src;
            if (ok && img) out.push(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120');
          });
          return out;
        })
        .catch(function () { return []; });
    }
    Promise.all([pick('gratis-schoen-new-balance', 2), pick('gratis-schoen-ugg', 1)]).then(function (r) {
      var urls = r[0].concat(r[1]).slice(0, 3);
      if (urls.length) {
        try { sessionStorage.setItem('abcd_prize_v1', JSON.stringify({ t: Date.now(), u: urls })); } catch (e) {}
        showThumbs(urls);
      }
    });
  }
  function showThumbs(urls) {
    thumbs.innerHTML = urls.map(function (u) { return '<img alt="" loading="lazy" src="' + u + '">'; }).join('');
    prize.hidden = false;
  }
  var prizeStarted = false;
  function startPrize() { if (prizeStarted) return; prizeStarted = true; loadPrize(); }

  /* ---------- cart writes ---------- */
  var busy = false;
  function post(url, body) {
    return fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function refreshDrawer() { document.dispatchEvent(new CustomEvent('cart:refresh')); }

  /* write gift properties on the first line in ONE request.
     map: { 'Cadeau sokken': 'Zwart · 38-42', ... }; a value of '' removes that property. */
  function writeProps(map) {
    if (busy) return Promise.resolve();
    var keys = Object.keys(map);
    if (!keys.length) return Promise.resolve();
    busy = true;
    var removing = keys.every(function (k) { return map[k] === ''; });
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var idx = -1, i;
        for (i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (isProt(it) || it.requires_shipping === false) continue;
          if (removing) {
            if (keys.some(function (k) { return it.properties && it.properties[k]; })) { idx = i; break; }
          } else { idx = i; break; }
        }
        if (idx < 0) return null;
        var line = cart.items[idx];
        var props = {};
        var existing = line.properties || {};
        Object.keys(existing).forEach(function (k) { props[k] = existing[k]; });
        keys.forEach(function (k) { if (map[k] === '') delete props[k]; else props[k] = map[k]; });
        /* always send the current quantity: change.js with only properties resets the line to 1,
           which undid the + in the drawer as soon as a gift unlocked (2026-10-24) */
        return post('/cart/change.js', { id: line.key, quantity: line.quantity, properties: props });
      })
      .then(function (res) { busy = false; if (res !== null) refreshDrawer(); }, function () { busy = false; fails++; });
  }
  var fails = 0;
  function one(k, v) { var o = {}; o[k] = v; return o; }

  /* ---------- gifts: chosen for the shopper, changeable with one tap ---------- */
  var SEP = ' · ';
  var editing = false;
  var lastTry = { sig: '', t: 0 };
  function parseSock(v) {
    var p = String(v || '').split(SEP);
    return { color: p[0] || 'Zwart', size: p[1] || '38-42' };
  }
  /* sock size from the first shoe size in the cart (EU number), 38-42 when unknown */
  function defaultSize(items) {
    for (var i = 0; i < items.length; i++) {
      var m = /EU\s*([\d.]+)/i.exec(items[i].variant_title || '');
      if (m) { var n = parseFloat(m[1]); return n < 38 ? '34-38' : (n <= 42 ? '38-42' : '42-46'); }
    }
    return '38-42';
  }
  function showSock(v) { var p = parseSock(v); return colorName(p.color) + SEP + p.size; }
  function chip(label, on, attrs, dot) {
    return '<button type="button" class="AbcdGift__chip' + (on ? ' is-on' : '') + '" aria-pressed="' + (on ? 'true' : 'false') + '" ' + attrs + '>' +
      (dot ? '<span class="AbcdGift__dot" style="background:' + dot + '"></span>' : '') + label + '</button>';
  }
  function colorName(c) { return (L.colors && L.colors[c]) || c; }
  function esc(t) {
    return String(t == null ? '' : t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function renderGifts(a) {
    var want1 = a.net >= t1();
    var want2 = a.net >= t2();
    var sv = a.props[KEY_SOCKS];
    var lv = a.props[KEY_LACES];
    var html = '';
    if (want1 && sv) {
      var list = '<span>' + L.socksOk + ': <b>' + esc(showSock(sv)) + '</b></span>' + (want2 && lv ? '<span>' + L.lacesOk + ': <b>' + esc(colorName(lv)) + '</b></span>' : '');
      html = '<div class="AbcdGift"><div class="AbcdGift__top">' + ICON.gift + '<strong>' + L.giftsT + '</strong><button type="button" data-edit aria-expanded="' + (editing ? 'true' : 'false') + '" aria-label="' + L.giftsT + ': ' + (editing ? L.done : L.change) + '">' + (editing ? L.done : L.change) + '</button></div><div class="AbcdGift__list">' + list + '</div>';
      if (editing) {
        var cs = parseSock(sv);
        html += '<div class="AbcdGift__edit"><p>' + L.socksOk + '</p>' +
          '<div class="AbcdGift__chips">' + SOCK_COLORS.map(function (c) { return chip(colorName(c), cs.color === c, 'data-sc="' + c + '"', SOCK_DOT[c]); }).join('') + '</div>' +
          '<div class="AbcdGift__chips">' + SOCK_SIZES.map(function (s) { return chip(s, cs.size === s, 'data-ss="' + s + '"'); }).join('') + '</div>';
        if (want2 && lv) {
          html += '<p>' + L.lacesOk + '</p><div class="AbcdGift__chips">' + LACE_COLORS.map(function (c) { return chip(colorName(c), lv === c, 'data-lc="' + c + '"', LACE_DOT[c]); }).join('') + '</div>';
        }
        html += '</div>';
      }
      html += '</div>';
    }
    if (giftsBox.getAttribute('data-sig') !== html) {
      giftsBox.innerHTML = html;
      giftsBox.setAttribute('data-sig', html);
    }
    giftsBox.hidden = !html;
  }

  giftsBox.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('button');
    if (!b || !last) return;
    var v, cs;
    if (b.hasAttribute('data-edit')) { editing = !editing; renderGifts(last); return; }
    if ((v = b.getAttribute('data-sc'))) { cs = parseSock(last.props[KEY_SOCKS]); return writeProps(one(KEY_SOCKS, v + SEP + cs.size)); }
    if ((v = b.getAttribute('data-ss'))) { cs = parseSock(last.props[KEY_SOCKS]); return writeProps(one(KEY_SOCKS, cs.color + SEP + v)); }
    if ((v = b.getAttribute('data-lc'))) { return writeProps(one(KEY_LACES, v)); }
  });

  /* ---------- paint ---------- */
  var last = null;
  var prev = { d1: null, d2: null, d3: null };
  var FALLBACK_TIERS = [['1 artikel', '5% met code'], ['2 artikelen', '5% korting'], ['3+ artikelen', '10% korting']];
  /* the tier texts come from the (translated) bundle box that is still rendered, but hidden */
  function tierText(n, tag) {
    var node = document.querySelector('#CartDrawerPro .OxUp [data-oxup-tier="' + n + '"] ' + tag);
    return (node && node.textContent.trim()) || FALLBACK_TIERS[n - 1][tag === 'strong' ? 0 : 1];
  }

  function paint(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    var a = analyse(cart);
    last = a;
    cur = a.currency || 'EUR';
    if (a.count === 0) { el.hidden = true; giftsBox.hidden = true; giftsBox.innerHTML = ''; giftsBox.removeAttribute('data-sig'); editing = false; prev = { d1: null, d2: null, d3: null }; return; }
    if (!noShoe()) startPrize();
    el.hidden = false;

    var T1 = t1(), T2 = t2(), T3 = t3();
    var NS = noShoe();
    var gap3 = a.applied ? 0 : Math.max(0, T3 - a.shoeSpend);
    var d1 = a.net >= T1;
    var d2 = a.net >= T2;
    var d3 = !NS && (a.applied || (a.shoeSpend >= T3));
    var shoeReady = d3 && !a.applied;
    var b = band();

    var title, sub;
    if (a.applied) { title = L.E; sub = L.Esub; }
    else if (shoeReady) { title = L.D; sub = L.Dsub; }
    else if (d2) { title = L.C.replace('[x]', money(gap3, true)); sub = L.Csub; }
    else if (d1) { title = L.B.replace('[x]', money(T2 - a.net, true)); sub = L.Bsub; }
    else { title = L.A.replace('[x]', money(T1 - a.net, true)); sub = L.Asub; }
    sub = sub.replace('[min]', money(b.min, true)).replace('[max]', money(b.max, true)).replace('[shoe]', money(T3, true)).replace('[t2]', money(T2, true));
    if (tTitle.innerHTML !== title) tTitle.innerHTML = title;
    if (tSub.textContent !== sub) tSub.textContent = sub;

    /* bar: one segment per step, so each amount ends exactly on its circle (nodes at 50, 75 and 100 percent):
       0 to T1 on the cart total, T1 to T2 on the cart total, T2 to T3 on the shoe spend; full once the shoe is unlocked */
    var pct;
    if (NS) pct = d2 ? 100 : (d1 ? 50 + 50 * Math.min(0.97, (a.net - T1) / (T2 - T1)) : Math.max(2, Math.min(48, 50 * a.net / T1)));
    else if (d3) pct = 100;
    else if (d2) pct = 75 + 25 * Math.min(0.97, Math.max(0, a.shoeSpend - T2) / (T3 - T2));
    else if (d1) pct = 50 + 25 * Math.min(0.97, (a.net - T1) / (T2 - T1));
    else pct = Math.max(2, Math.min(48, 50 * a.net / T1));
    tFill.style.width = pct + '%';
    track.setAttribute('aria-valuenow', String(Math.round(pct)));

    var done = [d1, d2, d3];
    var nextIdx = d1 ? (d2 ? (d3 || NS ? -1 : 2) : 1) : 0;
    var amounts = [T1, T2, T3];
    var names = [L.n1, L.n2, L.n3];
    var keys = ['d1', 'd2', 'd3'];
    for (var i = 0; i < 3; i++) {
      var node = q('[data-node="' + (i + 1) + '"]');
      var lab = q('[data-lab="' + (i + 1) + '"]');
      node.classList.toggle('is-done', done[i]);
      node.classList.toggle('is-next', i === nextIdx);
      var icon = done[i] ? ICON.check : (i === 0 ? ICON.truck : (i === 1 ? ICON.gift : ICON.shoe));
      var sig = done[i] ? 'c' : 'i' + i;
      if (node.getAttribute('data-sig') !== sig) { node.innerHTML = icon; node.setAttribute('data-sig', sig); }
      if (prev[keys[i]] === false && done[i]) {
        node.classList.remove('is-pop'); void node.offsetWidth; node.classList.add('is-pop');
      }
      prev[keys[i]] = done[i];
      lab.classList.toggle('is-done', done[i]);
      lab.querySelector('b').textContent = money(amounts[i], true);
      lab.querySelector('i').textContent = names[i];
    }
    /* bundle tiers: 1 item, 2 items 5 percent, 3 or more 10 percent (gift lines are properties, not items) */
    var tierActive = a.count >= 3 ? 3 : (a.count === 2 ? 2 : 1);
    var tierNext = a.count >= 3 ? 0 : (a.count === 2 ? 3 : 2);
    for (var tn = 1; tn <= 3; tn++) {
      var te = q('[data-tier="' + tn + '"]');
      te.classList.toggle('is-active', tn === tierActive);
      te.classList.toggle('is-next', tn === tierNext);
      var ts = te.querySelector('strong'), tm = te.querySelector('em');
      var t1x = tierText(tn, 'strong'), t2x = tierText(tn, 'em');
      if (ts.textContent !== t1x) ts.textContent = t1x;
      if (tm.textContent !== t2x) tm.textContent = t2x;
    }
    /* The free pair is never combined with the 5 or 10 percent bundle discount (2026-10-24), so once it is
       in the cart the tiers would promise a discount that no longer applies: hide them. */
    var tiersEl = q('[data-tiers]');
    if (tiersEl) tiersEl.style.display = a.applied ? 'none' : '';
    el.setAttribute('data-state', a.applied ? 'E' : (shoeReady ? 'D' : (d2 ? 'C' : (d1 ? 'B' : 'A'))));
    el.classList.toggle('is-locked-shoe', !d3);
    cta.hidden = !shoeReady;
    renderGifts(a);

    /* the gifts follow the steps: added when a step is reached, removed when it is lost */
    var drop = {}, need = {};
    if (!d1 && a.props[KEY_SOCKS]) drop[KEY_SOCKS] = '';
    if (!d2 && a.props[KEY_LACES]) drop[KEY_LACES] = '';
    if (d1 && !a.props[KEY_SOCKS]) need[KEY_SOCKS] = 'Zwart' + SEP + defaultSize(a.items);
    if (d2 && !a.props[KEY_LACES]) need[KEY_LACES] = 'Zwart';
    var todo = Object.keys(drop).length ? drop : need;
    var tsig = JSON.stringify(todo);
    if (!busy && fails < 3 && Object.keys(todo).length && !(lastTry.sig === tsig && Date.now() - lastTry.t < 6000)) {
      lastTry = { sig: tsig, t: Date.now() };
      writeProps(todo);
    }
  }

  document.addEventListener('cdp:updated', function (e) {
    if (e && e.detail && e.detail.cart) paint(e.detail.cart);
  });

  /* safety net: if the drawer events do not fire, follow the cart requests */
  var refreshing = null;
  function pull() {
    if (refreshing) return;
    refreshing = setTimeout(function () {
      refreshing = null;
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paint, function () {});
    }, 150);
  }
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var u = arguments[0];
      var href = typeof u === 'string' ? u : (u && u.url) || '';
      var p = origFetch.apply(this, arguments);
      if (href.indexOf('/cart/') !== -1 && href.indexOf('/cart.js') === -1) { p.then(pull, function () {}); }
      return p;
    };
  }

  /* soft failure: if the card never appears while the drawer has items, bring the old bar back */
  setTimeout(function () {
    if (el.hidden && root.querySelector('.cdp__item')) root.classList.remove('abcd-ladder-on');
  }, 4000);
  var boot = document.getElementById('CartDrawerProCart');
  if (boot) { try { paint(JSON.parse(boot.textContent)); } catch (e) { pull(); } } else { pull(); }
})();
